import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormBackground } from '../../AdminRoutes/CreateRoutes/CreateForm.styles';
import { httpSendReminderEmail } from '../../Hooks/user/user.post.hooks';
import SecondaryButton from '../../Components/Buttons/SecondaryButton/SecondaryButton.component';

const SendReminderEmailButton = ({ userId, courseId }) => {
  const [status, setStatus] = useState('');

  const sendEmail = async (e) => {
    e.preventDefault();
    setStatus('Sending email...');
    const course = { courseId, userId, reminderDate: null };
    const response = await httpSendReminderEmail(course);
    const data = await response.json();
    if (response.ok) {
      setStatus(data.msg || 'Email sent successfully');
    } else {
      setStatus(data.msg || 'Failed to send email');
    }
  };

  return (
    <FormBackground>
      <h4>Send a Reminder Email</h4>
      <form
        onSubmit={sendEmail}
        style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}
      >
        <div className="buttonGroup">
          <SecondaryButton
            span="Send Reminder Email"
            functionName={sendEmail}
          />
        </div>
      </form>
      {status.length > 0 && <p className="result">{status}</p>}
    </FormBackground>
  );
};

SendReminderEmailButton.propTypes = {
  userId: PropTypes.string.isRequired,
  courseId: PropTypes.string.isRequired,
};

export default SendReminderEmailButton;
